export default __webpack_public_path__ + "static/media/sbj-zoology.6d4fbeb0.svg";